export default "__VITE_ASSET__BBjPx8ut__"